<template>
  <div class="display-card-selector">
    <van-radio-group v-model="radio" icon-size="90%" checked-color="red">
      <van-radio name="-1">请选择</van-radio>
      <van-radio v-for="card in cards" :name="card" :key="card.id">
        {{ card.type }}
      </van-radio>
    </van-radio-group>
    <van-row type="flex" justify="center">
      <van-col span="12" @click="handleRadio(false)">
        取消
      </van-col>
      <van-col span="12" style="color:red;border-left:1px solid #eee" @click="handleRadio(true)">
        确认
      </van-col>
    </van-row>
  </div>
</template>
<script>
export default {
  props: {
    cards: [Array],
  },
  data() {
    return {
      radio: '-1',
    };
  },
  methods: {
    handleRadio(type) {
      if (!type || this.radio === '-1') {
        this.radio = '-1';
      }
      this.$emit('change', this.radio, type);
    },
  },
};
</script>
<style lang="less" scoped>
.display-card-selector {
  .van-radio-group {
    padding: 0 5%;
    .van-radio {
      margin: 15px 10px;
    }
  }
  .van-row {
    border-top: 1px solid #eee;
    text-align: center;
    .van-col {
      line-height: 40px;
      align-self: center;
    }
  }
}
</style>
